import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Tengo que esperar a cumplir 67 años?',
  a: 'No, puedes reclamar desde los 60, aunque el monto varía.'
}, {
  q: '¿Qué pasa si me vuelvo a casar?',
  a: 'Si lo haces después de los 60 años, generalmente conservas el beneficio.'
}, {
  q: '¿El trámite es lento?',
  a: 'Puede serlo, por eso cada día que esperas es dinero perdido.'
}, {
  q: '¿Necesito un abogado?',
  a: 'En el 90% de los casos no, solo necesitas la información correcta que está en esta guía.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="space-y-4 w-full" data-id="element-4">
      {faqs.map((faq, i) => <div key={i} className="border border-[#7B2D3B]/20 rounded-xl overflow-hidden bg-white/60 shadow-sm" data-id="element-5">
          <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-white/40 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-6">
            <span className="font-serif font-medium text-lg text-[#7B2D3B] pr-4" data-id="element-7">
              {faq.q}
            </span>
            <ChevronDown className={`w-5 h-5 text-[#7B2D3B] flex-shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-8" />
          </button>
          <AnimatePresence data-id="element-9">
            {openIndex === i && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} data-id="element-10">
                <div className="px-6 pb-5 text-gray-700 leading-relaxed" data-id="element-11">
                  {faq.a}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}